/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupContractMemberDto } from './GroupContractMemberDto';
import {
    GroupContractMemberDtoFromJSON,
    GroupContractMemberDtoFromJSONTyped,
    GroupContractMemberDtoToJSON,
    GroupContractMemberDtoToJSONTyped,
} from './GroupContractMemberDto';

/**
 * 
 * @export
 * @interface GroupContractWithMembersDto
 */
export interface GroupContractWithMembersDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractWithMembersDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractWithMembersDto
     */
    contractIdentifier: string;
    /**
     * Stable contract type code ("C" cadre, "G" groupe).
     * @type {string}
     * @memberof GroupContractWithMembersDto
     */
    typeCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupContractWithMembersDto
     */
    typeLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupContractWithMembersDto
     */
    subscriberName?: string | null;
    /**
     * Settlement mode. False = the subscriber pays for every member, and its single mandate must be attached to each of them. True = each member carries its own mandate.
     * @type {boolean}
     * @memberof GroupContractWithMembersDto
     */
    billedByMembers: boolean;
    /**
     * Calendar date, no timezone — display as-is, never convert.
     * @type {string}
     * @memberof GroupContractWithMembersDto
     */
    startDate?: string | null;
    /**
     * True if at least one active tunnel of the group contract carries a mandate. In "the subscriber pays for all" mode, a group contract without a mandate can feed none of its members.
     * @type {boolean}
     * @memberof GroupContractWithMembersDto
     */
    hasGroupMandate: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupContractWithMembersDto
     */
    memberCount: number;
    /**
     * Members with no mandate — as many contracts nothing can be debited from.
     * @type {number}
     * @memberof GroupContractWithMembersDto
     */
    membersWithoutMandateCount: number;
    /**
     * 
     * @type {Array<GroupContractMemberDto>}
     * @memberof GroupContractWithMembersDto
     */
    members: Array<GroupContractMemberDto>;
}

/**
 * Check if a given object implements the GroupContractWithMembersDto interface.
 */
export function instanceOfGroupContractWithMembersDto(value: object): value is GroupContractWithMembersDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('billedByMembers' in value) || value['billedByMembers'] === undefined) return false;
    if (!('hasGroupMandate' in value) || value['hasGroupMandate'] === undefined) return false;
    if (!('memberCount' in value) || value['memberCount'] === undefined) return false;
    if (!('membersWithoutMandateCount' in value) || value['membersWithoutMandateCount'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function GroupContractWithMembersDtoFromJSON(json: any): GroupContractWithMembersDto {
    return GroupContractWithMembersDtoFromJSONTyped(json, false);
}

export function GroupContractWithMembersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractWithMembersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contractIdentifier': json['contractIdentifier'],
        'typeCode': json['typeCode'] == null ? undefined : json['typeCode'],
        'typeLabel': json['typeLabel'] == null ? undefined : json['typeLabel'],
        'subscriberName': json['subscriberName'] == null ? undefined : json['subscriberName'],
        'billedByMembers': json['billedByMembers'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'hasGroupMandate': json['hasGroupMandate'],
        'memberCount': json['memberCount'],
        'membersWithoutMandateCount': json['membersWithoutMandateCount'],
        'members': ((json['members'] as Array<any>).map(GroupContractMemberDtoFromJSON)),
    };
}

export function GroupContractWithMembersDtoToJSON(json: any): GroupContractWithMembersDto {
    return GroupContractWithMembersDtoToJSONTyped(json, false);
}

export function GroupContractWithMembersDtoToJSONTyped(value?: GroupContractWithMembersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contractIdentifier': value['contractIdentifier'],
        'typeCode': value['typeCode'],
        'typeLabel': value['typeLabel'],
        'subscriberName': value['subscriberName'],
        'billedByMembers': value['billedByMembers'],
        'startDate': value['startDate'],
        'hasGroupMandate': value['hasGroupMandate'],
        'memberCount': value['memberCount'],
        'membersWithoutMandateCount': value['membersWithoutMandateCount'],
        'members': ((value['members'] as Array<any>).map(GroupContractMemberDtoToJSON)),
    };
}

